<template>
  <div id="page"></div>
  <orderMseeage />
</template>
<script lang="ts" setup>
import { onMounted, nextTick } from "vue";
import { useSdkStore } from "@/stores/sdk";
import { initSdk } from "@/sdk/init";
import { setfontList } from "@/common/design";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute()
const sdkStore = useSdkStore();
import { initDesign } from '@/common/initDesign'
//@ts-ignore
import orderMseeage from '@/components/orderMseeage.vue'
onMounted(async () => {
  await nextTick();
  const desginsdk = await initSdk("#page");
  sdkStore.setSdk(desginsdk);
  await setfontList()
  initDesign()
});
</script>
<style lang="scss">
.custom-thin {
  position: fixed;
  top: 10px;
  left: 10px;
}
</style>
